import React from "react";
import "../App.css";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import "primeicons/primeicons.css";
import "primereact/resources/themes/nova-light/theme.css";
import "primereact/resources/primereact.css";
import "primeflex/primeflex.css";
import { Paginator } from "primereact/paginator";
import Popover from "react-bootstrap/Popover";
import Moment from "moment";


class MMPLCalibrationDueList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      first: 0
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);

  }



  render() {
    const { pageSize, totalRecords, arraylist } = this.props;
    return (
      <div className="pb-4">
        <div className="row">
          <div className="col-lg-12">
            <div className="p-0">
              <div className="row">
                <div className="col-sm-12">{this.renderCardPendingData()}</div>
              </div>
            </div>
          </div>
        </div>

        {arraylist && arraylist.length ? (
          <div className="custom-paginator">
            <Paginator
              first={this.state.first}
              rows={pageSize}
              totalRecords={totalRecords}
              onPageChange={(e) => this.onPaginatorChange(e)}
            ></Paginator>
          </div>
        ) : (
          <div
            className="card"
            style={{ overflow: "hidden", position: "relative" }}
          >
            <div class="container">
              <h6 className="resource-list-title no-item-card">!-- No Items to Display --!</h6>
            </div>
          </div>
        )}
      </div>
    );
  }

  onPaginatorChange(event) {
    const { setUpdatedState } = this.props;
    this.setState({ first: event.first });
    setUpdatedState(event.page + 1);
  }

  renderCardPendingData = () => {
    const { arraylist } = this.props;
    return arraylist && arraylist.length
      ? arraylist.map((item, index) => {
        return (
          <div
            className="card mb-1 mt-2"
            style={{
              overflow: "hidden",
              position: "relative",
              marginBottom: "5px",
            }}
          >
            <div className="p-3">
              <div className="resource-list-auth-date">
                <div className="row">
                  <div className="col-sm-12 col-md-12 col-m-auto">
                    <div className="row">
                      <div className="col-sm-4 col-md-4">
                        <span>
                          <strong>Device Id: </strong>
                          <span className="italicFont ">
                            {item ? item.deviceId : ""}
                          </span>
                        </span>
                      </div>
                      <div className="col-sm-4 col-md-4 mb-1">
                        <span>
                          <strong>Company Name : </strong>
                          <span className="italicFont ">
                            {item ? item.clinetName : ""}
                          </span>
                        </span>
                      </div>
                      <div className="col-sm-4 col-md-4 mb-1">
                        <span>
                          <strong>Ship Name : </strong>
                          <span className="italicFont ">
                            {item ? item.shipname : ""}
                          </span>
                        </span>
                      </div>

                      <div className="col-sm-4 col-md-4 mb-1">
                        <span>
                          <strong>Last Calibration Date : </strong>
                          <span className="italicFont">
                            {item
                              ? Moment(
                                new Date(Date.parse(item.lastCalibrationDate))
                              ).format("DD MMM YYYY")
                              : ""}
                          </span>
                        </span>
                      </div>
                      <div className="col-sm-4 col-md-4">
                        <span>
                          <strong>Next Calibration Date : </strong>
                          <span className="italicFont ">
                            {item
                              ? Moment(
                                new Date(Date.parse(item.nextCalibrationDate))
                              ).format("DD MMM YYYY")
                              : ""}
                          </span>
                        </span>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      })
      : null;
  };
}

function mapStateToProps(state) {
  return {};
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(MMPLCalibrationDueList)
);
